import type { TraceMessage } from "../types";

/** Returns the user message text immediately preceding the assistant answer. */
export function extractPrecedingUserQuestion(
  messages: TraceMessage[],
  assistantMessageIndex: number,
): string {
  for (let index = assistantMessageIndex - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message?.role === "user") {
      return message.text;
    }
  }

  return "";
}
